import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import GrupoDetalle from './GrupoDetalles';
import GrupoEmpresa from './empresa/Empresa';
import GrupoProveedor from './proveedor/GrupoProveedor';
import GrupoContacto from './contactos/GrupoContacto';
import ServicioAsignado from './servicio/ServicioAsignado';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { createEntity, getEmpresasByGrupo, getEntity, reset, updateEntity } from './grupo-empresarial.reducer';
import { useAppDispatch, useAppSelector } from '../../store';
import WindowHeader from '../../commons/WindowHeader';
import GrupoEditarModal from './GrupoEditarModal';
import { getEntities as getEmpresaServicios } from '../empresa-servicio.reducer';
import { getEntities as getContactos } from '../contacto.reducer';
import { getProveedores, getServicios } from '../empresa.reducer';
import { toInteger } from 'lodash';

function Grupo() {
    const navigate = useNavigate();
    const location = useLocation();

    const dispatch = useAppDispatch();

    const loading = useAppSelector(state => state.grupoEmpresarial.loading);
    const grupoEmpresarialEntity = useAppSelector(state => state.grupoEmpresarial.entity) as any;

    const empresaServicios = useAppSelector(state => state.empresa.servicios) as any;
    const proveedores = useAppSelector(state => state.empresa.proveedores) as any;
    const contactos = useAppSelector(state => state.contacto.entities) as any;

    const empresas = useAppSelector(state => state.grupoEmpresarial.empresas) as any;

    const { grupoId } = useParams<'grupoId'>();
    const { empresaId } = useParams<'empresaId'>();

    const isEditGrupoRoute =
        grupoId != null &&
        grupoId !== 'new' &&
        location.pathname === `/empresas/grupo/${grupoId}/edit`;

    const navigateToEditGrupo = () => {
        navigate(`/empresas/grupo/${grupoId}/edit`, {
            state: { returnEmpresaId: empresaId },
        });
    };

    const closeEditGrupo = () => {
        const ret = (location.state as { returnEmpresaId?: string } | null)?.returnEmpresaId;
        if (ret != null && ret !== '') {
            navigate(`/empresas/grupo/${grupoId}/empresa/${ret}`);
        } else {
            navigate(`/empresas/grupo/${grupoId}`);
        }
    };

    useEffect(() => {
        if (grupoId === 'new') {
            navigate('/empresas/grupo/new', { replace: true });
        }
    }, [grupoId, navigate]);

    const isNew = grupoId === undefined;

    useEffect(() => {
        if (isNew || grupoId === 'new') {
            return;
        }
        dispatch(getEntity(grupoId));
        dispatch(getEmpresasByGrupo({ id: grupoId, page: 0, size: 99999 }));
        dispatch(getContactos({
            page: 0, size: 99999, sort: 'id,asc', filters: [
                { filterName: 'grupoId', filterValue: grupoId }
            ]
        }));
    }, [isNew, grupoId, dispatch]);


    useEffect(() => {
        console.log('actualizar empresa', empresaId);
        requestServicios();
        requestProveedores();
    }, [empresaId])

    const requestServicios = () => {
        if (empresaId != null) {
            dispatch(getServicios(toInteger(empresaId)));
        }

    }
    const requestProveedores = () => {
        if (empresaId != null) {
            dispatch(getProveedores(toInteger(empresaId)));
        }
    }



    console.log('App loading');


    if (loading)
        return <>Loading...</>

    const seleccionarEmpresa = (empresa: any) => {
        navigate(`/empresas/grupo/${grupoId}/empresa/${empresa.id}`);
    }

    const deseleccionarEmpresa = (empresa: any) => {
        navigate(`/empresas/grupo/${grupoId}`);
    }

    return (
        <div>
            <div className="row g-0">
                <WindowHeader
                    title={grupoEmpresarialEntity.alias}
                    onClose={() => {
                        navigate(`/empresas`);
                    }}
                    onEditGrupo={
                        grupoId != null && grupoId !== 'new' && !isEditGrupoRoute
                            ? navigateToEditGrupo
                            : undefined
                    }
                />
                <GrupoEditarModal
                    open={isEditGrupoRoute}
                    onClose={closeEditGrupo}
                    grupoId={grupoId}
                />
                <div>

                </div>
                <div className="col-12 col-md-8 border p-4" style={{ minWidth: 0, overflow: 'hidden' }}>
                    <GrupoEmpresa grupoId={grupoId} empresaId={empresaId} empresas={empresas} seleccionarEmpresa={(empresa: any) => { seleccionarEmpresa(empresa) }} deseleccionarEmpresa={(empresa: any) => { deseleccionarEmpresa(empresa) }}></GrupoEmpresa>
                </div>
                <div className="col-12 col-md-4 border p-4" style={{ minWidth: 0, overflow: 'hidden' }}>
                    {proveedores && <GrupoProveedor proveedores={proveedores}></GrupoProveedor>}
                </div>
                <div className="col-12 col-md-6 border p-4" style={{ minWidth: 0, overflow: 'hidden' }}>
                    {contactos && <GrupoContacto grupoId={grupoId} contactos={contactos}></GrupoContacto>}
                </div>
                <div className="col-12 col-md-6 border p-4" style={{ minWidth: 0, overflow: 'hidden' }}>
                    {empresaServicios && <ServicioAsignado empresaServicios={empresaServicios}></ServicioAsignado>}
                </div>
            </div >
        </div >
    );
}

export default Grupo;
